/** Default value prop on signup / login popups (LoginSignupBanner, game intro modals). */
export const SIGNUP_LOGIN_POPUP_MESSAGE =
    "Join free to get the fastest live match data and play our fun games!";

/** Footer disclaimer on signup / login popups. */
export const SIGNUP_LOGIN_POPUP_DISCLAIMER =
    "Free-to-play cricket games. In game currencies have no monetary value and cannot be exchanged or withdrawn for cash";
